"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createEntityKey(data) {
    if (data.type && data.id) {
        return data.type + "-" + data.id;
    }
    return '';
}
var JsonDeserializer = /** @class */ (function () {
    function JsonDeserializer(propertiesMapper) {
        this.cachedModels = {};
        this.setPropertiesMapper(propertiesMapper);
    }
    JsonDeserializer.prototype.setPropertiesMapper = function (pm) {
        this.pm = pm;
    };
    JsonDeserializer.prototype.setJsonParsedObject = function (body) {
        this.body = body;
    };
    JsonDeserializer.prototype.build = function () {
        var data = this.body.data;
        var staff;
        if (Array.isArray(data)) {
            staff = [];
            var collectionLength = data.length;
            for (var i = 0; i < collectionLength; i++) {
                if (data[i]) {
                    var model = this.buildModelByData(data[i]);
                    if (model) {
                        staff.push(model);
                    }
                }
            }
        }
        else if (data) {
            staff = this.buildModelByData(data);
        }
        return staff;
    };
    JsonDeserializer.prototype.buildModelByData = function (data) {
        var entityKey = createEntityKey(data);
        var model;
        if (entityKey) {
            // checks for built model in cachedModels is a protection from creating models on recursive relationships
            model = this.cachedModels[entityKey];
            if (model) {
                return model;
            }
        }
        model = this.pm.createModel(data.type);
        if (model) {
            if (entityKey) {
                this.cachedModels[entityKey] = model;
            }
            this.pm.setId(model, data.id);
            if (data.attributes) {
                this.pm.setAttributes(model, data.attributes);
            }
            if (data.meta && this.pm.setMeta) {
                this.pm.setMeta(model, data.meta);
            }
            if (data.links && this.pm.setLinks) {
                this.pm.setLinks(model, data.links);
            }
            var relationships = this.buildRelationsByData(data, model);
            if (relationships) {
                this.pm.setRelationships(model, relationships);
            }
        }
        return model;
    };
    JsonDeserializer.prototype.buildRelationsByData = function (data, model) {
        var readyRelations = {};
        if (data.relationships) {
            for (var k in data.relationships) {
                var relation = data.relationships[k];
                if (Array.isArray(relation.data)) {
                    readyRelations[k] = [];
                    var relationItemsLength = relation.data.length;
                    for (var i = 0; i < relationItemsLength; i++) {
                        var dataItem = this.buildDataFromIncluded(relation.data[i].id, relation.data[i].type);
                        readyRelations[k].push(this.buildModelByData(dataItem));
                    }
                }
                else if (relation.data) {
                    var dataItem = this.buildDataFromIncluded(relation.data.id, relation.data.type);
                    readyRelations[k] = this.buildModelByData(dataItem);
                }
                if (relation.links) {
                    var setRelationshipLinks = this.pm.setRelationshipLinks;
                    if (setRelationshipLinks) {
                        setRelationshipLinks(model, k, relation.links);
                    }
                }
                if (relation.meta) {
                    var setRelationshipMeta = this.pm.setRelationshipMeta;
                    if (setRelationshipMeta) {
                        setRelationshipMeta(model, k, relation.meta);
                    }
                }
            }
        }
        if (Object.keys(readyRelations).length) {
            return readyRelations;
        }
        return null;
    };
    JsonDeserializer.prototype.buildDataFromIncluded = function (id, type) {
        var included = this.buildIncludedInObject();
        var dataItem = included[type + id];
        if (dataItem) {
            return dataItem;
        }
        else {
            return { id: id, type: type };
        }
    };
    JsonDeserializer.prototype.buildIncludedInObject = function () {
        if (!this.includedInObject) {
            this.includedInObject = {};
            if (this.body.included) {
                var includedLength = this.body.included.length;
                for (var i = 0; i < includedLength; i++) {
                    var item = this.body.included[i];
                    this.includedInObject[item.type + item.id] = item;
                }
            }
        }
        return this.includedInObject;
    };
    return JsonDeserializer;
}());
exports.default = JsonDeserializer;
//# sourceMappingURL=JsonDeserializer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/jsona/lib/builders/JsonDeserializer.js
// module id = 482
// module chunks = 0